import { Suspense } from 'react';
import { useAuth } from 'react-oidc-context';
import { Outlet } from 'react-router-dom';
import Loading from '~/components/loading/Loading';
import ConnectionStatus from '~/components/connection-status/connection-status';
import SettingsWrapper from '~/lib/settings/settings-wrapper';

export function Component() {
  const { isAuthenticated } = useAuth();
  return (
    <Suspense fallback={<></>}>
      {isAuthenticated ? (
        <SettingsWrapper>
          <Outlet />
        </SettingsWrapper>
      ) : (
        <Loading />
      )}
      <ConnectionStatus />
    </Suspense>
  );
}

Component.displayName = 'Settings';
